import { PhaseDiagramsCompare } from "../projects/competence/PhaseDiagramsCompare";

export const MatchingDecider = () => {

    return <div>
        <h2>Persönliche Weiterentwicklung</h2>
        <PhaseDiagramsCompare graphForChoice={"PERSONAL_COMPETENCE"} />
    </div>
};